import firebase from '../../services/firebase';

export const setUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_USER',
      payload: user,
    });
  };
};

export const registerUser = (email, password, name, phoneNumber) => {
  return async (dispatch) => {
    try {
      const { user } = await firebase.createAccount(email, password);
      await firebase.addUser(user.uid, { name, phoneNumber });
      dispatch(setUser({ uid: user.uid, name, phoneNumber, isAuthenticated: true }));
    } catch (error) {
      console.error('Error registering user:', error);
      throw error;
    }
  };
};

export const loginUser = (email, password) => {
  return async (dispatch) => {
    try {
      const { user } = await firebase.signIn(email, password);
      const userData = await firebase.getUser(user.uid);
      if (userData.exists) {
        dispatch(
          setUser({
            uid: user.uid,
            name: userData.data().name,
            phoneNumber: userData.data().phoneNumber,
            isAuthenticated: true,
          })
        );
      } else {
        console.error('User data not found in Firestore');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      throw error;
    }
  };
};

export const logoutUser = () => {
  return async (dispatch) => {
    try {
      await firebase.signOut();
      dispatch(setUser(null));
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };
};